.placeholder {
  --ixf-asset-logo-placeholder-font-size: 1rem; // 16px @ medium (32px)

  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 1px solid var(--ixf-color-separator);
  border-radius: var(--ixf-asset-logo-border-radius);
  background: var(--ixf-color-background);
  font-family: var(--ixf-font-family-main);
  font-weight: 500;
  font-size: var(--ixf-asset-logo-placeholder-font-size);
  line-height: var(--ixf-asset-logo-placeholder-font-size);
  color: var(--ixf-color-neutral-dk);
  text-align: center;
  user-select: none;

  &.size {
    &-small {
      --ixf-asset-logo-placeholder-font-size: 0.75rem; // 12px @ 24px
    }

    &-x-small {
      --ixf-asset-logo-placeholder-font-size: 0.5rem; // 8px @ 16px
    }
  }
}
